<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <button mat-raised-button routerLink="/sites" class="m-1 mr-2">
    <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
  </button>

  <button mat-raised-button *ngIf="child_id" [routerLink]="'/sites/'+parent_id+'/children'" class="m-1 mr-2">
    <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}
  </button>

  <button
    mat-raised-button
    [routerLink]="utils.prepareSiteRelatedLink(site_id, child_id ? parent_id : null, 'edit/audits')"
    class="m-1 mr-2">
    <mat-icon>arrow_back</mat-icon> Inspections & Audits
  </button>

  <button
    mat-raised-button
    [routerLink]="utils.prepareSiteRelatedLink(site_id, child_id ? parent_id : null, 'edit/audits/' + audit.id + '/view')"
    *ngIf="audit?.id"
    class="m-1 mr-2">
    <mat-icon>remove_red_eye</mat-icon>
    View
  </button>

  <button mat-raised-button (click)="delete(audit)" *ngIf="audit?.id" color="warn" class="m-1 mr-2">
    <mat-icon>delete</mat-icon>
    Delete
  </button>
</nav>

<div class="container-fluid p-0">
  <div class="card rounded-0">
    <div class="card-body">

      <div class="container-fluid p-0">
        <div class="card">
          <div class="card-body">

            <div class="card-title">
              <h6>Inspection/Audit</h6>
            </div>

            <form #form="ngForm" (ngSubmit)="onSubmit()">
              <mat-form-field class="full-width mb-4 pt-2" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Inspection/Audit</mat-label>
                <input
                  matInput
                  placeholder="Inspection/Audit"
                  [(ngModel)]="audit.name"
                  name="name"
                  type="text"
                  required
                  #name />
                <mat-error *ngIf="!name.valid">Please enter an Inspection/Audit name.
                </mat-error>
              </mat-form-field>

              <mat-form-field class="full-width mb-4 pt-2" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Positive Comments</mat-label>
                <input
                  matInput
                  placeholder="Positive Comments"
                  [(ngModel)]="audit.positive_comments"
                  name="positive_comments"
                  type="text" />
              </mat-form-field>

              <div class="row">
                <div class="col">
                  <button
                    mat-raised-button
                    [disabled]="!form.valid || inProgress"
                    color="primary"
                    (click)="onSubmit()"
                    class="my-2 ml-0 mr-2"
                    type="button">
                    <mat-icon>save</mat-icon>
                    Save
                  </button>

                  <button
                    mat-raised-button
                    color="secondary"
                    class="my-2 ml-1 mr-2"
                    id="contractors-button"
                    [matBadge]="'' + audit?.contractor_ids?.length"
                    type="button"
                    (click)="onSelectContractors()">
                    <fa-icon [icon]="faHardHat"></fa-icon>
                    Associate {{ utils.getLangTerm('contractors.plural', 'Contractors') }}
                  </button>

<!--                  Hidden until this feature is expanded in a future phase -->
<!--                  <button-->
<!--                    mat-raised-button-->
<!--                    class="my-2 ml-1 mr-2"-->
<!--                    type="button"-->
<!--                    color="secondary"-->
<!--                    id="assets_selector_button"-->
<!--                    (click)="onSelectAssets()"-->
<!--                    [matBadge]="'' + (audit?.asset_ids?.length)"-->
<!--                    matTooltip="Select the assets you want the inspection/audit associated with.">-->
<!--                    <mat-icon>forklift</mat-icon>-->
<!--                    Associate Assets-->
<!--                  </button>-->
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>
